import React, { Component } from "react";
import "./index.css";
import HamburgerMenu from "./Components/HamburgerMenu";
import { Link } from "redux-little-router";
import { CASEMASTERS_LOGO_URL } from "../../constants/urls.js";

class PublicHeader extends Component {
  state = { open: false };
  toggleMenu() {
    this.setState(prevState => ({ open: !prevState.open }));
  }
  render() {
    return (
      <header className="navbar">
        <div className="navbar__desktop">
          <h1 className="navbar__desktop__logo">
            <a href="/">
              <img className="navbar__desktop__logo__img" alt="logo" src={CASEMASTERS_LOGO_URL} />
            </a>
          </h1>

          <div className="navbar__desktop__menu">
            <ul>
              <li className="navbar__desktop__menu__item">
                <a href="https://blog.casemasters.com" className="navbar__desktop__menu__item__link">
                  Blog
                </a>
              </li>
              <li className="navbar__desktop__menu__item">
                <Link href="/about" className="navbar__desktop__menu__item__link">
                  About Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="navbar__mobile">
          <div className="navbar__mobile__head">
            <h1 className="navbar__mobile__head__logo">
              <a href="/">
                <img className="navbar__mobile__head__logo__img" alt="logo" src={CASEMASTERS_LOGO_URL} />
              </a>
            </h1>
            <HamburgerMenu toggleMenu={this.toggleMenu.bind(this)} />
          </div>
          <div className={`navbar__mobile__menu animated ${this.state.open ? "fadein" : "fadeOut"}`}>
            <div className="navbar__mobile__menu__controls">
              <ul
                className={`navbar__mobile__menu__controls__list
                  ${this.state.open ? "navbar__mobile__menu__controls__list--open" : ""}`}
              >
                <li className="navbar__mobile__menu__controls__list__item">
                  <a href="https://blog.casemasters.com">Blog</a>
                </li>
                <li className="navbar__mobile__menu__controls__list__item">
                  <Link href="/about">About Us</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default PublicHeader;



// WEBPACK FOOTER //
// ./src/components/PublicHeader/index.js